export enum AppStorageKeys {
  User = "###",
  UpdatedUser = "######",
}
export enum APIResponseCode {
  Success = "00",
  BadRequest = "ERR_BAD_REQUEST",
  RedirectToXpressPay = "05",
  DoesNotExist = "02",
}

export enum BillTabNumber {
  Airtime = 0,
  Data = 1,
}

export enum PaymentMethod {
  XpressWallet = 1,
  XpressPay = 2,
}
export enum PaymentMethodResponse {
  XpressWallet = "Wallet",
  XpressPay = "XpressPay",
}
export enum PurchaseCategory {
  Airtime = 1,
  Data,
  Electricity,
  Betting,
  Cable,
  Education,
  WaecRegistration,
  Insurance,
  WaecPin,
  WaecVerification,
  Jamb,
  Neco,
  Nabtech,
}

export enum PurchaseCategoryForApi {
  Airtime = 1,
  Data,
  Cable,
  Electricity,
  Betting,
  Insurance,
  WaecRegistration,
  WaecPin,
  WaecVerification,
  Jamb,
  Neco,
  Nabtech,
}

export enum BillCategory {
  Airtime = "airtime",
  Data = "data",
  Cable = "cable",
  Electricity = "electricity",
  Education = "education",
  Betting = "betting",
  Insurance = "insurance",
}
